import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-certificate-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class CertificateForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: string;

  public formModel: AnyEntity = {};

  // created() {}
  mounted() {
    //
  }

  destroyed() {
    /* this.$root.$off('changeActivityType'); */
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }
}
